import {
  EMPTY_FOOTER_DESCRIPTION,
  type FooterDescriptionContent,
} from '@/types/footer-description';

/**
 * Raw payload returned by the backend for the footer-description
 * static-page row (`GET /static-pages/slug/footer`). The description
 * text lives in `content` on the wire (matching how FAQ / Terms /
 * Privacy persist their body text), so this shape mirrors the admin
 * service's `BackendFooterDescription`.
 */
export interface BackendFooterDescription {
  id?: number | null;
  title?: string | null;
  slug?: string | null;
  content?: string | null;
  updatedAt?: Date | string | null;
  [key: string]: unknown;
}

/**
 * Coerce a backend row into the frontend's `FooterDescriptionContent`.
 * Returns `EMPTY_FOOTER_DESCRIPTION` for a null/undefined input so the
 * caller never needs to null-check.
 */
export function mergeWithDefaults(
  input: BackendFooterDescription | null | undefined,
): FooterDescriptionContent {
  if (!input) return { ...EMPTY_FOOTER_DESCRIPTION };
  return {
    id: input.id ?? null,
    title: typeof input.title === 'string' ? input.title : '',
    slug: typeof input.slug === 'string' ? input.slug : '',
    description: typeof input.content === 'string' ? input.content : '',
    updatedAt: input.updatedAt ?? null,
  };
}
